// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — grid.classic.js, новая — grid.cp.js
import { isCp } from 'libs/design';
import * as classic from './grid.classic';
import * as cp from './grid.cp';

export const CommentBox = isCp ? cp.CommentBox : classic.CommentBox;
export const Error = isCp ? cp.Error : classic.Error;
export const Grid = isCp ? cp.Grid : classic.Grid;
export const GridBox = isCp ? cp.GridBox : classic.GridBox;
export const GridCell = isCp ? cp.GridCell : classic.GridCell;
export const GridCellFirst = isCp ? cp.GridCellFirst : classic.GridCellFirst;
export const GridCellLast = isCp ? cp.GridCellLast : classic.GridCellLast;
export const GridCellLock = isCp ? cp.GridCellLock : classic.GridCellLock;
export const GridCellNumber = isCp ? cp.GridCellNumber : classic.GridCellNumber;
export const GridContainer = isCp ? cp.GridContainer : classic.GridContainer;
export const GridRow = isCp ? cp.GridRow : classic.GridRow;
export const LongZoneIcon = isCp ? cp.LongZoneIcon : classic.LongZoneIcon;
export const Option = isCp ? cp.Option : classic.Option;
export const OptionsCell = isCp ? cp.OptionsCell : classic.OptionsCell;
export const OptionsPopup = isCp ? cp.OptionsPopup : classic.OptionsPopup;
export const OptionsSeparator = isCp ? cp.OptionsSeparator : classic.OptionsSeparator;
export const PaymentsTableHeaders = isCp ? cp.PaymentsTableHeaders : classic.PaymentsTableHeaders;
export const RepalceFormBox = isCp ? cp.RepalceFormBox : classic.RepalceFormBox;
export const ReplaceFormText = isCp ? cp.ReplaceFormText : classic.ReplaceFormText;
export const ReplaceListButton = isCp ? cp.ReplaceListButton : classic.ReplaceListButton;
export const Submit = isCp ? cp.Submit : classic.Submit;
export const SubmitAll = isCp ? cp.SubmitAll : classic.SubmitAll;
export const SubmitAllPlace = isCp ? cp.SubmitAllPlace : classic.SubmitAllPlace;
export const TableHead = isCp ? cp.TableHead : classic.TableHead;
export const TableHeadRow = isCp ? cp.TableHeadRow : classic.TableHeadRow;
export const TableHeaders = isCp ? cp.TableHeaders : classic.TableHeaders;
export const TableRow = isCp ? cp.TableRow : classic.TableRow;
export const TableSortHeaders = isCp ? cp.TableSortHeaders : classic.TableSortHeaders;
export const Total = isCp ? cp.Total : classic.Total;
export const ZoneIcon = isCp ? cp.ZoneIcon : classic.ZoneIcon;
